import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FAQ_POPULAR_IDS, resolveFaqItemById } from '../../data/faqData';
import './FaqPopularTopics.css';

export function FaqPopularTopics() {
  const { t } = useTranslation();

  return (
    <section className="saas-faq-pop" aria-labelledby="saas-faq-pop-title">
      <h2 id="saas-faq-pop-title" className="saas-faq-pop__title">
        {t('faq.popularTitle')}
      </h2>
      <ul className="saas-faq-pop__list">
        {FAQ_POPULAR_IDS.map((id) => {
          const item = resolveFaqItemById(t, id);
          if (!item) return null;
          return (
            <li key={id}>
              <Link to={`/faq?id=${id}`} className="saas-faq-pop__link">
                {item.question}
              </Link>
            </li>
          );
        })}
      </ul>
    </section>
  );
}
